// Carregamento condicionado ao consentimento das ferramentas de
// analytics/marketing confirmadas com o cliente (ver data/legal.js).
// Cada loader só injeta o script se o ID real já tiver sido preenchido —
// enquanto for o placeholder "TODO_...", a função não faz nada (nenhum
// request sai do navegador), pra política de cookies e código ficarem
// coerentes mesmo antes de ativar cada ferramenta.

import { MARKETING_IDS } from "@/data/legal";

const isConfigured = (id) => typeof id === "string" && id.length > 0 && !id.startsWith("TODO_");

const alreadyInjected = (id) => Boolean(document.getElementById(id));

function loadGoogleAnalytics() {
  const id = MARKETING_IDS.googleAnalyticsId;
  const scriptId = "mn-script-ga4";
  if (!isConfigured(id) || alreadyInjected(scriptId)) return;

  const script = document.createElement("script");
  script.id = scriptId;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  gtag("js", new Date());
  gtag("config", id);
}

function loadGoogleTagManager() {
  const id = MARKETING_IDS.googleTagManagerId;
  const scriptId = "mn-script-gtm";
  if (!isConfigured(id) || alreadyInjected(scriptId)) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });

  const script = document.createElement("script");
  script.id = scriptId;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${id}`;
  document.head.appendChild(script);
}

function loadMetaPixel() {
  const id = MARKETING_IDS.metaPixelId;
  const scriptId = "mn-script-meta-pixel";
  if (!isConfigured(id) || alreadyInjected(scriptId)) return;

  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.id = "mn-script-meta-pixel";
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */

  window.fbq("init", id);
  window.fbq("track", "PageView");
}

/** Chamado quando a categoria "Analíticos e marketing" é aceita. */
export function loadMarketingScripts() {
  loadGoogleAnalytics();
  loadGoogleTagManager();
  loadMetaPixel();
}
